//Masks (Top)
import redButton from '../Images/Masks/RedButtonMask.png';
import blueButton from '../Images/Masks/BlueButtonMask.png';
import yellowButton from '../Images/Masks/YellowButtonMask.png';
import greenButton from '../Images/Masks/GreenButtonMask.png';
import whiteButton from '../Images/Masks/WhiteButtonMask.png';
import purpleButton from '../Images/Masks/PurpleButtonMask.png';
import tealButton from '../Images/Masks/TealButtonMask.png';
import blackButton from '../Images/Masks/BlackButtonMask.png';

//Rays (Middle)
import redRay from '../Images/Rays/RedRay.png';
import blueRay from '../Images/Rays/BlueRay.png';
import yellowRay from '../Images/Rays/YellowRay.png';
import greenRay from '../Images/Rays/GreenRay.png';
import whiteRay from '../Images/Rays/WhiteRay.png';
import purpleRay from '../Images/Rays/PurpleRay.png';
import tealRay from '../Images/Rays/TealRay.png';
import blackRay from '../Images/Rays/BlackRay.png';

//Bases (Bottom)
import topLeftBase from '../Images/ButtonBases/TopLeftBase.png';
import topRightBase from '../Images/ButtonBases/TopRightBase.png';
import bottomLeftBase from '../Images/ButtonBases/BottomLeftBase.png';
import bottomRightBase from '../Images/ButtonBases/BottomRightBase.png';

//Sounds
import redSound from '../Sounds/Red.wav';
import blueSound from '../Sounds/Blue.wav';
import yellowSound from '../Sounds/Yellow.wav';
import greenSound from '../Sounds/Green.wav';
import whiteSound from '../Sounds/White.wav';
import purpleSound from '../Sounds/Purple.wav';
import tealSound from '../Sounds/Teal.wav';
import blackSound from '../Sounds/Black.wav';
import dud from '../Sounds/Dud.wav';
import redSoundFast from '../Sounds/RedFast.wav';
import blueSoundFast from '../Sounds/BlueFast.wav';
import yellowSoundFast from '../Sounds/YellowFast.wav';
import greenSoundFast from '../Sounds/GreenFast.wav';
import whiteSoundFast from '../Sounds/WhiteFast.wav';
import purpleSoundFast from '../Sounds/PurpleFast.wav';
import tealSoundFast from '../Sounds/TealFast.wav';
import blackSoundFast from '../Sounds/BlackFast.wav';
import dudFast from '../Sounds/DudFast.wav';
import gameOver from '../Sounds/GameOver.wav';


class Button {
  constructor(id, buttonName, keyName, maskImg, maskName, rayImg, rayName, baseImg, baseName, lightOn, lightOff, sound, soundFast, startActive) {
    this._id = id;
    this._buttonName = buttonName;
    this._keyName = keyName;
    this._maskImg = maskImg;
    this._maskName = maskName;
    this._rayImg = rayImg;
    this._rayName = rayName;
    this._baseImg = baseImg;
    this._baseName = baseName;
    this._lightOn = lightOn;
    this._lightOff = lightOff;
    this._dormant = "rgb(125, 125, 125)";
    if (startActive === true) {
      this._lightState = this._lightOff;
      this._active = true;
    } else if (startActive === false) {
      this._lightState = this._dormant;
      this._active = false;
    }
    this._rayState = 0;
    this._sound = new Audio(sound);
    this._soundFast = new Audio(soundFast);
    this._dudSound = new Audio(dud);
    this._dudSoundFast = new Audio(dudFast);
    this._revealed = false;
  }

  get id() {
    return this._id;
  }

  get buttonName() {
    return this._buttonName;
  }

  get keyName() {
    return this._keyName;
  }

  get maskImg() {
    return this._maskImg;
  }

  get maskName() {
    return this._maskName;
  }

  get rayImg() {
    return this._rayImg;
  }

  get rayName() {
    return this._rayName;
  }

  get baseImg() {
    return this._baseImg;
  }

  get baseName() {
    return this._baseName;
  }

  get lightState() {
    return this._lightState;
  }

  lightOn() {
    this._lightState = this._lightOn;
  }

  lightOff() {
    this._lightState = this._lightOff;
  }

  get rayState() {
    return this._rayState;
  }

  rayOn() {
    this._rayState = 1;
  }

  rayOff() {
    this._rayState = 0;
  }
  //A light VALUE to set the appearance of the side buttons not active
  get dormant() {
    return this._dormant;
  }

  slumber() {
    this._lightState = this._dormant;
  }

  get revealed() {
    return this._revealed;
  }

  reveal() {
    this._revealed = true;
  }

  hide() {
    this._revealed = false;
  }
  //A STATUS CHECK to see if a button is active
  get active() {
    return this._active;
  }

  activate() {
    this._active = true;
  }

  deactivate() {
    this._active = false;
  }

  get sound() {
    return this._sound;
  }

  get soundFast() {
    return this._soundFast;
  }

  //Event Reveals
  smooth() {
    this.lightOn();
    this.rayOn();
    this._sound.currentTime = 0;
    this._sound.play();
  }

  blitz() {
    this.lightOn();
    this.rayOn();
    this._soundFast.currentTime = 0;
    this._soundFast.play();
  }

  off() {
    this.lightOff();
    this.rayOff();
  }

  noLight() {
    this._sound.currentTime = 0;
    this._sound.play();
  }

  noLightFast() {
    this._soundFast.currentTime = 0;
    this._soundFast.play();
  }

  noSound() {
    this.lightOn();
    this.rayOn();
  }

  noSoundFast() {
    this.lightOn();
    this.rayOn();
  }

  spinLeft() {
    this.lightOn();
    this.rayOn();
    this._sound.currentTime = 0;
    this._sound.play();
    Stroop.rotation -= 90;
  }

  spinLeftFast() {
    this.lightOn();
    this.rayOn();
    this._soundFast.currentTime = 0;
    this._soundFast.play();
    Stroop.rotation -= 90;
  }

  spinRight() {
    this.lightOn();
    this.rayOn();
    this._sound.currentTime = 0;
    this._sound.play();
    Stroop.rotation += 90;
  }

  spinRightFast() {
    this.lightOn();
    this.rayOn();
    this._soundFast.currentTime = 0;
    this._soundFast.play();
    Stroop.rotation += 90;
  }

  dud() {
    this._dudSound.currentTime = 0;
    this._dudSound.play();
  }

  dudFast() {
    this._dudSoundFast.currentTime = 0;
    this._dudSoundFast.play();
  }
}

const red = new Button(0, 'redButton', "red", redButton, "redButtonMask", redRay, "redRay", topLeftBase, "redBase", 'rgb(255, 0, 0)', 'rgb(125, 0, 0)', redSound, redSoundFast, true);
const blue = new Button(1, 'blueButton', "blue", blueButton, 'blueButtonMask', blueRay, 'blueRay', topRightBase, 'blueBase', 'rgb(0, 0, 255)', 'rgb(0, 0, 125)', blueSound, blueSoundFast, true);
const yellow = new Button(2, 'yellowButton', 'yellow', yellowButton, 'yellowButtonMask', yellowRay, 'yellowRay', bottomLeftBase, 'yellowBase', 'rgb(255, 255, 0)', 'rgb(125, 125, 0)', yellowSound, yellowSoundFast, true);
const green = new Button(3, 'greenButton', 'green', greenButton, 'greenButtonMask', greenRay, 'greenRay', bottomRightBase, 'greenBase', 'rgb(0, 255, 0)', 'rgb(0, 125, 0)', greenSound, greenSoundFast, true);
const white = new Button(4, 'whiteButton', 'white', whiteButton, 'whiteButtonMask', whiteRay, 'whiteRay', topRightBase, 'whiteBase', 'rgb(255, 255, 255)', 'rgb(175, 175, 175)', whiteSound, whiteSoundFast, false);
const purple = new Button(5, 'purpleButton', 'purple', purpleButton, 'purpleButtonMask', purpleRay, 'purpleRay', bottomRightBase, 'purpleBase', 'rgb(255, 0, 255)', 'rgb(125, 0, 125)', purpleSound, purpleSoundFast, false);
const teal = new Button(6, 'tealButton', 'teal', tealButton, 'tealButtonMask', tealRay, 'tealRay', topLeftBase, 'tealBase', 'rgb(0, 255, 255)', 'rgb(0, 125, 125)', tealSound, tealSoundFast, false);
const black = new Button(7, 'blackButton', 'black', blackButton, 'blackButtonMask', blackRay, 'blackRay', bottomLeftBase, 'blackBase', 'rgb(0, 0, 0)', 'rgb(50, 50, 50)', blackSound, blackSoundFast, false);
const failSound = new Audio(gameOver);

const Stroop = {
  buttonArray: [red, blue, yellow, green, white, purple, teal, black],
  mainButtonArray: [red, blue, yellow, green],
  sideButtonArray: [white, purple, teal, black],
  defaultActiveButtons: ["red", "blue", "yellow", "green"],
  activeButtons: ["red", "blue", "yellow", "green"],
  buttons: {
    red: red,
    blue: blue,
    yellow: yellow,
    green: green,
    white: white,
    purple: purple,
    teal: teal,
    black: black
  },
  failSound: failSound,
  //Expected Back-End Migration
  mode: "Menu",
  round: 1,
  eventIndex: 0,
  respondIndex: 0,
  totalScore: 0,
  roundScore: 0,
  snagBonus: 1,
  highScore: 0,
  eventArray: [],
  revealArray: [],
  revealIndex: 0,
  reveals: 1,
  respondArray: [],
  rotation: 0,
  snagArray: ["noLight", "noSound", "spinLeft", "spinRight", "dud", "blitzReminder"],
  snagInfo: {
    noLights: false,
    noSound: false,
    dud: false,
    spin: false,
    extraEvent: false,
    extraButtons: false,
  },
  revealedSnags: [],
  readSnags: 0,
  unreadSnags: false,
  beginGame() {
    this.mode = "Revealing";
    this.round = 1;
    this.roundScore = 0;
    this.totalScore = 0;
    this.snagBonus = 1;
    this.prepareSequenceReveal(this.round);
  },
  warn() {
    this.mode = "Get Ready!";
  },
  startRound() {
    this.mode = "Revealing";
  },
  extendPattern(round) {
    if (Math.random()*100 < this.round) {
      let nextEvent = Math.floor(Math.random()*4);
      //console.log(`A special roll ${this.sideButtonArray[nextEvent].keyName}`);
      this.snagBonus++;
      this.snagInfo.extraButtons = true;
      if (!this.revealedSnags.includes("extraButtons")) {
        this.revealedSnags.push("extraButtons");
        //console.log(this.revealedSnags);
        if (this.revealedSnags.length > this.readSnags) {
          this.unreadSnags = true;

        } else {
          this.unreadSnags = false;
        }
        //console.log(this.unreadSnags);
      }
      this.eventArray.push(this.sideButtonArray[nextEvent]);
    } else {
      let nextEvent = Math.floor(Math.random()*4);
      //console.log(`A standard roll ${this.mainButtonArray[nextEvent].keyName}`);
      this.eventArray.push(this.mainButtonArray[nextEvent]);
    }
    if (Math.random() * 100 < this.round) {
      this.snagBonus++;
      this.snagInfo.extraEvent = true;
      this.reveals = 2;
      if (!this.revealedSnags.includes("extraEvent")) {
        this.revealedSnags.push("extraEvent");
        //console.log(this.revealedSnags);
        if (this.revealedSnags.length > this.readSnags) {
          this.unreadSnags = true;
        } else {
          this.unreadSnags = false;
        }
        //console.log(this.unreadSnags);
      }
      if (Math.random()*100 < this.round) {
        let nextEvent = Math.floor(Math.random()*4);
        //console.log(`A special roll on an extra reveal ${this.sideButtonArray[nextEvent].keyName}`);
        this.snagBonus++;
        this.snagInfo.extraButtons = true;
        if (!this.revealedSnags.includes("extraButtons")) {
          this.revealedSnags.push("extraButtons");
          //console.log(this.revealedSnags);
          if (this.revealedSnags.length > this.readSnags) {
            this.unreadSnags = true;

          } else {
            this.unreadSnags = false;
          }
          //console.log(this.unreadSnags);
        }
        this.eventArray.push(this.sideButtonArray[nextEvent]);
      } else {
        let nextEvent = Math.floor(Math.random()*4);
        //console.log(`A standard roll on an extra reveal ${this.mainButtonArray[nextEvent].keyName}`);
        this.eventArray.push(this.mainButtonArray[nextEvent]);
      }
    }
  },
  prepareSequenceReveal(round) {
    this.revealArray = [];
    this.extendPattern(round);
    for (let i=0; i<this.eventArray.length; i++) {
      let reveal = "smooth";
      let duration;
      let snagPriority = [];
      let tempSnags = ["noLight", "noSound", "dud", "spinLeft", "spinRight", "blitzReminder"];
      let fastSnags = ["spinLeftFast", "spinRightFast"];
      if (this.revealArray.length > 0) {
        tempSnags.pop();
      }
      while (tempSnags.length > 0 && fastSnags.length > 0) {
        if (i>0 && this.revealArray[0][1] === "blitzReminder" && i < this.eventArray.length - this.reveals) {
          let snagIndex = Math.floor(Math.random() * fastSnags.length);
          snagPriority.push(fastSnags[snagIndex]);
          fastSnags.splice(snagIndex, 1);
          duration = this.eventArray[i].soundFast.duration;
        } else {
          let snagIndex = Math.floor(Math.random() * tempSnags.length);
          snagPriority.push(tempSnags[snagIndex]);
          tempSnags.splice(snagIndex, 1);
          duration = this.eventArray[i].sound.duration;
        }
      }
      for (let j=0; j<snagPriority.length; j++) {
        if (Math.random() * 100 < round - 1) {
            reveal = snagPriority[j];
        }
      }
      if (reveal === "blitzReminder") {
        this.snagBonus++;
        duration = this.eventArray[0].soundFast.duration;
      }
      this.revealArray.push([this.eventArray[i], reveal, duration]);
      //this.revealArray[0] = [this.eventArray[0], "blitzReminder", this.eventArray[0].soundFast.duration];
      //console.log(`${this.revealArray[i][0].keyName} with a ${this.revealArray[i][1]} reveal`);
    }
  },
  beginEventReveal(eventPairing) {
    if (!eventPairing[0].active) {
      eventPairing[0].activate();
    }
    if (eventPairing[1] === "spinLeft") {
      eventPairing[0].spinLeft();
      this.snagBonus++;
      this.snagInfo.spin = true;
      if (!this.revealedSnags.includes("spin")) {
        this.revealedSnags.push("spin");
        //console.log(this.revealedSnags);
        if (this.revealedSnags.length > this.readSnags) {
          this.unreadSnags = true;
        } else {
          this.unreadSnags = false;
        }
        //console.log(this.unreadSnags);
      }
      eventPairing[0].reveal();
    } if (eventPairing[1] === "spinLeftFast") {
      eventPairing[0].spinLeft();
      setTimeout(function() {
        eventPairing[0].sound.pause();
        eventPairing[0].sound.currentTime = 0;
      }, eventPairing[0].soundFast.duration * 1000);
      this.snagBonus++;
      this.snagInfo.spin = true;
      if (!this.revealedSnags.includes("spin")) {
        this.revealedSnags.push("spin");
        //console.log(this.revealedSnags);
        if (this.revealedSnags.length > this.readSnags) {
          this.unreadSnags = true;
        } else {
          this.unreadSnags = false;
        }
        //console.log(this.unreadSnags);
      }
      eventPairing[0].reveal();
    } else if (eventPairing[1] === "spinRight") {
      eventPairing[0].spinRight();
      this.snagBonus++;
      this.snagInfo.spin = true;
      if (!this.revealedSnags.includes("spin")) {
        this.revealedSnags.push("spin");
        //console.log(this.revealedSnags);
        if (this.revealedSnags.length > this.readSnags) {
          this.unreadSnags = true;
        } else {
          this.unreadSnags = false;
        }
        //console.log(this.unreadSnags);
      }
      eventPairing[0].reveal();
    } else if (eventPairing[1] === "spinRightFast") {
      eventPairing[0].spinRight();
      setTimeout(function() {
        eventPairing[0].sound.pause();
        eventPairing[0].sound.currentTime = 0;
      }, eventPairing[0].soundFast.duration * 1000);
      this.snagBonus++;
      this.snagInfo.spin = true;
      if (!this.revealedSnags.includes("spin")) {
        this.revealedSnags.push("spin");
        //console.log(this.revealedSnags);
        if (this.revealedSnags.length > this.readSnags) {
          this.unreadSnags = true;
        } else {
          this.unreadSnags = false;
        }
        //console.log(this.unreadSnags);
      }
      eventPairing[0].reveal();
    } else if (eventPairing[1] === "noLight") {
      if (eventPairing[0].revealed) {
        eventPairing[0].noLight();
        this.snagBonus++;
        this.snagInfo.noLights = true;
        if (!this.revealedSnags.includes("noLights")) {
          this.revealedSnags.push("noLights");
          //console.log(this.revealedSnags);
          if (this.revealedSnags.length > this.readSnags) {
            this.unreadSnags = true;
          } else {
            this.unreadSnags = false;
          }
          //console.log(this.unreadSnags);
        }
      } else {
        eventPairing[0].smooth();
        //console.log("No Lights But Unrevealed!");
        eventPairing[0].reveal();
      }
    } else if (eventPairing[1] === "noLightFast") {
      if (eventPairing[0].revealed) {
        eventPairing[0].noLight();
        setTimeout(function() {
          eventPairing[0].sound.pause();
          eventPairing[0].sound.currentTime = 0;
        }, eventPairing[0].soundFast.duration * 1000);
        this.snagBonus++;
        this.snagInfo.noLights = true;
        if (!this.revealedSnags.includes("noLights")) {
          this.revealedSnags.push("noLights");
          //console.log(this.revealedSnags);
          if (this.revealedSnags.length > this.readSnags) {
            this.unreadSnags = true;
          } else {
            this.unreadSnags = false;
          }
          //console.log(this.unreadSnags);
        }
      } else {
        eventPairing[0].smooth();
        //console.log("No Lights But Unrevealed!");
        eventPairing[0].reveal();
      }
    } else if (eventPairing[1] === "noSound") {
      if (eventPairing[0].revealed) {
        eventPairing[0].noSound();
        this.snagBonus++;
        this.snagInfo.noSound = true;
        if (!this.revealedSnags.includes("noSound")) {
          this.revealedSnags.push("noSound");
          //console.log(this.revealedSnags);
          if (this.revealedSnags.length > this.readSnags) {
            this.unreadSnags = true;
          } else {
            this.unreadSnags = false;
          }
          //console.log(this.unreadSnags);
        }
      } else {
        eventPairing[0].smooth();
        //console.log("No Sound But Unrevealed!");
        eventPairing[0].reveal();
      }
    } else if (eventPairing[1] === "noSoundFast") {
      if (eventPairing[0].revealed) {
        eventPairing[0].noSound();
        this.snagBonus++;
        this.snagInfo.noSound = true;
        if (!this.revealedSnags.includes("noSound")) {
          this.revealedSnags.push("noSound");
          //console.log(this.revealedSnags);
          if (this.revealedSnags.length > this.readSnags) {
            this.unreadSnags = true;
          } else {
            this.unreadSnags = false;
          }
          //console.log(this.unreadSnags);
        }
      } else {
        eventPairing[0].smooth();
        //console.log("No Sound But Unrevealed!");
        eventPairing[0].reveal();
      }
    } else if (eventPairing[1] === "dud") {
      if (this.revealIndex < this.revealArray.length - this.reveals) {
        if (eventPairing[0].revealed) {
        eventPairing[0].dud();
        this.snagBonus++;
        this.buttonArray.forEach(button => {
          button.slumber();
        });
        this.snagInfo.dud = true;
        if (!this.revealedSnags.includes("dud")) {
          this.revealedSnags.push("dud");
          //console.log(this.revealedSnags);
          if (this.revealedSnags.length > this.readSnags) {
            this.unreadSnags = true;
          } else {
            this.unreadSnags = false;
          }
          //console.log(this.unreadSnags);
        }}
      } else {
        eventPairing[0].smooth();
        //console.log("Dud But Unrevealed!");
        eventPairing[0].reveal();
      }
    } else if (eventPairing[1] === "dudFast") {
      if (this.revealIndex < this.revealArray.length - this.reveals) {
        if (eventPairing[0].revealed) {
        eventPairing[0].dud();
        setTimeout(function() {
          eventPairing[0].sound.pause();
          eventPairing[0].sound.currentTime = 0;
        }, eventPairing[0].soundFast.duration * 1000);
        this.snagBonus++;
        this.buttonArray.forEach(button => {
          button.slumber();
        });
        this.snagInfo.dud = true;
        if (!this.revealedSnags.includes("dud")) {
          this.revealedSnags.push("dud");
          //console.log(this.revealedSnags);
          if (this.revealedSnags.length > this.readSnags) {
            this.unreadSnags = true;
          } else {
            this.unreadSnags = false;
          }
          //console.log(this.unreadSnags);
        }}
      } else {
        eventPairing[0].smooth();
        //console.log("Dud But Unrevealed!");
        eventPairing[0].reveal();
      }
    } else if (this.revealArray[0][1] === "blitzReminder" && this.revealIndex < this.revealArray.length - this.reveals) {
      eventPairing[0].smooth();
      //console.log(this.revealIndex);
      setTimeout(function() {
        eventPairing[0].sound.pause();
        eventPairing[0].sound.currentTime = 0;
      }, eventPairing[0].soundFast.duration * 1000);
      this.snagInfo.blitzReminder = true;
      if (!this.revealedSnags.includes("blitzReminder")) {
        this.revealedSnags.push("blitzReminder");
        //console.log(this.revealedSnags);
        if (this.revealedSnags.length > this.readSnags) {
          this.unreadSnags = true;
        } else {
          this.unreadSnags = false;
        }
        //console.log(this.unreadSnags);
      }
    } else {
      eventPairing[0].smooth();
      eventPairing[0].reveal();
    }
  },
  endEventReveal(eventIndex) {
    this.buttonArray.forEach(button => {
      if (button.active) {
        button.off();
      }
    });
    if (eventIndex + 1 === this.revealArray.length) {
      this.mode = "Responding";
      //console.log("Responding");
    }
  },
  respond(color) {
    this.revealIndex = 0;
    this.reveals = 1;
    if (color === this.eventArray[this.respondIndex].keyName) {
      Stroop.buttons[color].sound.currentTime = 0;
      Stroop.buttons[color].sound.play();
      this.respondIndex++;
      this.roundScore += this.respondIndex * this.round;
      if (this.totalScore > this.highScore) {
        this.highScore = this.totalScore;
        //console.log(this.highScore);
        localStorage.setItem('stroopHighScore', this.highScore);
        //console.log("Test: "+testVariable);
      }
      if (this.respondIndex >= this.eventArray.length) {
        //console.log("Onto The Next Round!");
        this.roundScore *= this.snagBonus;
        this.totalScore += this.roundScore;
        if (this.totalScore > this.highScore) {
          this.highScore = this.totalScore;
          localStorage.setItem('stroopHighScore', this.highScore);
        }
        this.round += 1;
        this.roundScore = 0;
        this.snagBonus = 1;
        this.respondIndex = 0;
        this.mode = "Get Ready!";
        this.prepareSequenceReveal(this.round);
      }
    } else {
      Stroop.failSound.play();
      this.gameOver();
      this.mode = "Game Over";
      //console.log("Game Over!");
    }
  },
  gameOver() {
    this.mode = "Menu";
    this.round = 1;
    this.eventArray = [];
    this.rotation = 0;
    this.respondIndex = 0;
    this.revealIndex = 0;
    this.buttons.white.deactivate();
    this.buttons.purple.deactivate();
    this.buttons.teal.deactivate();
    this.buttons.black.deactivate();
    this.buttonArray.forEach(button => {
      if (button.active) {
        button.off();
      } else {
        button.slumber();
      }
      button.hide();
    });
  },
  updateReadSnags() {
    this.readSnags = this.revealedSnags.length;
    this.unreadSnags = false;
  },
  loadHighScore() {
    this.highScore = Number(localStorage.getItem('stroopHighScore'));
    //console.log(localStorage.getItem('stroopHighScore'));
    //console.log(Number(localStorage.getItem('stroopHighScore')));
    //console.log(this.highScore);
  }
}

export default Stroop;



// WEBPACK FOOTER //
// ./src/util/Stroop.js